window.emblaInstances = window.emblaInstances || {
  _instances: {},

  add(id, instance) {
    if (!id) throw new Error('Embla instance requires an id');
    this._instances[id] = instance;
  },

  getById(id) {
    return this._instances[id] || null;
  },

  getAll() {
    return Object.values(this._instances);
  },
};

document.addEventListener('DOMContentLoaded', () => {
  emblaJsInit();
});

function emblaJsInit(){
  document.querySelectorAll('.embla').forEach((root) => {
    const viewport = root.querySelector('.embla__viewport');
    const prevBtn = root.querySelector('.embla__prev');
    const nextBtn = root.querySelector('.embla__next');
    
    const emblaDragFree = root.dataset.emblaDragfree === 'true';
    const emblaLoop = root.dataset.emblaLoop === 'true';
    
    const startIndex = parseInt(root.dataset.startIndex || 0, 10);
    
    const OPTIONS = { dragFree: emblaDragFree, loop: emblaLoop, startIndex };
    const emblaId = root.dataset.emblaId;
    if (window.EmblaCarousel && emblaId) {
      const embla = EmblaCarousel(viewport, OPTIONS);

      window.emblaInstances.add(emblaId, embla);

      prevBtn.addEventListener('click', () => embla.scrollPrev());
      nextBtn.addEventListener('click', () => embla.scrollNext());

      const toggleButtons = () => {
        prevBtn.disabled = !embla.canScrollPrev();
        nextBtn.disabled = !embla.canScrollNext();
      };

      embla.on('select', toggleButtons);
      embla.on('init', toggleButtons);
    }
  });
}